/* unplugin-vue-components disabled */import script from "./DataCollectTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DataCollectTable.vue?vue&type=script&setup=true&lang=js"

import "./DataCollectTable.vue?vue&type=style&index=0&id=22b519e8&scoped=true&lang=css"
import "./DataCollectTable.vue?vue&type=style&index=1&id=22b519e8&lang=css"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22b519e8"]])

export default __exports__